import { useCallback } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { uberOpenExternalLink } from "@hopper-b2b/utilities";
import styles from "./styles.module.scss";

export const TripsIsRyanair = () => {
  const { t } = useI18nContext();

  const goToRyanair = useCallback(() => {
    const url = "https://ryanair.com";
    uberOpenExternalLink(url);
  }, []);

  return (
    <div className={styles.TripsIsRyanair}>
      <h2 className="title">{t("tripReviewLinks.checkInForFlight")}</h2>
      <p className="subtitle">{t("ryanairBooking.subtitle")}</p>
      <button onClick={goToRyanair} className="action-link">
        {t("ryanairBooking.actionText")}
      </button>
      <button className="action-secondary">{t("cancel")}</button>
    </div>
  );
};
